import {instance, onErrorFunction, onSuccessFunction} from "../../../config/axios-cnf";

export const buildMapUrl = (subjectId) => "/api/v2/enigoo/" + subjectId + "/map";
export const buildCommandUrl = (subjectId, turnstileId) => "/api/v2/enigoo/" + subjectId + "/turnstile/" + turnstileId + "/command";
export const buildOpenUrl = (subjectId, turnstileId) => "/api/v2/enigoo/" + subjectId + "/turnstile/" + turnstileId + "/open";

export const apiGetMap = (subjectId, callback, error) => {
    instance.get(buildMapUrl(subjectId)).then((r) => callback(onSuccessFunction(r.data))).catch((e) => error(onErrorFunction(e)));
};
export const apiGetTurnstileDetail = (subjectId, turnstileId, callback, error) => {
    instance.get("/api/v2/enigoo/" + subjectId + "/turnstile/" + turnstileId).then((r) => callback(onSuccessFunction(r.data))).catch((e) => error(onErrorFunction(e)));
};
// Pozor: proxy (turnikets_backend) posílá HTTP 200 i pro odmítnutý příkaz — chybu
// nese až tělo `{result: false, data: "<kód>"}`. Bez téhle kontroly by se
// COMMAND_PENDING i INVALID_PAYLOAD tvářily jako úspěch.
export const apiSendCommand = (subjectId, turnstileId, type, payload, callback, error) => {
    instance.post(buildCommandUrl(subjectId, turnstileId), {type, payload: payload || {}})
        .then((r) => {
            if (r?.data && r.data.result === false) {
                error(typeof r.data.data === "string" ? r.data.data : null);
                return;
            }
            callback(onSuccessFunction(r.data));
        })
        .catch((e) => error(onErrorFunction(e)));
};
export const apiOpenLegacy = (subjectId, turnstileId, callback, error) => {
    instance.get(buildOpenUrl(subjectId, turnstileId)).then((r) => callback(r.data)).catch((e) => error(onErrorFunction(e)));
};

export const buildTurnstileListUrl = (subjectId) => "/api/v2/enigoo/" + subjectId + "/turnstile";

export const apiGetTurnstileList = (subjectId, callback, error) => {
    instance.get(buildTurnstileListUrl(subjectId))
        .then((r) => callback(onSuccessFunction(r.data)))
        .catch((e) => error(onErrorFunction(e)));
};

export const apiPutMap = (subjectId, svg, callback, error) => {
    instance.put(buildMapUrl(subjectId), {svg})
        .then((r) => callback(onSuccessFunction(r.data)))
        .catch((e) => error(onErrorFunction(e)));
};

// Historie příkazů turniketu (jen socket validatory to mají; ostatní vrátí prázdné).
export const apiGetCommands = (subjectId, turnstileId, callback, error) => {
    instance.get(buildCommandUrl(subjectId, turnstileId))
        .then((r) => callback(onSuccessFunction(r.data)))
        .catch((e) => error(onErrorFunction(e)));
};

export const buildZoneListUrl = (subjectId) => "/api/v2/enigoo/" + subjectId + "/zone";

export const apiGetZones = (subjectId, callback, error) => {
    instance.get(buildZoneListUrl(subjectId))
        .then((r) => callback(onSuccessFunction(r.data)))
        .catch((e) => error(onErrorFunction(e)));
};
